<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <page-title>Approved Application</page-title>
    <!-- <search></search> -->
    <div class="has-background-white has-padding-30">
      <h2
        class="is-size-5 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black has-margin-bottom-20"
      >Approved Application</h2>
      <main-table
        :shipping-requests="ApprovedApplications"
        :default-sort="[sortField, sortOrder]"
        :default-sort-direction="defaultSortOrder"
        :isBackendPaginated="true"
        :currentPage="currentPage"
        :total="total"
        :onPageChange="onPageChange"
        canViewShippingRequest
      ></main-table>
    </div>
  </div>
</template>

<script>
import Search from "@/modules/commonModule/layouts/Search";
import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import MainTable from "../components/MainTable";
import GetShippingRequestByStatusQuery from "../api/graphql/queries/GetShippingRequestsByStatus.gql";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("shippers");

export default {
  components: { MainTable, Search },
  data() {
    return {
      sortField: "shipper_declaration_date",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      currentPage: 1,
      perPage: 10,
      total: 0,
      userID: null,
      isLoading: false
    };
  },
  mounted() {
    this.userID = this.getUserID();
    this.loadApprovedShippingRequests(this.currentPage);
  },
  computed: {
    ...mapGetters({
      ApprovedApplications: "getApprovedApplications"
    })
  },
  methods: {
    ...mapMutations({
      saveApprovedShippingRequests:
        SHIPPER_MUTATION_TYPES.SAVE_APPROVED_SHIPPING_REQUESTS
    }),

    getUserID() {
      return this.$store.getters.getUserID;
    },
    loadApprovedShippingRequests: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetShippingRequestByStatusQuery,
          variables: {
            user_id: this.userID,
            status: "APPROVED",
            count: 10,
            page
          }
        })
        .then(response => {
          const shippingRequests =
            response.data.getAShippersShippingRequestsByStatus.data;

          this.saveApprovedShippingRequests(shippingRequests);

          const {
            total,
            currentPage
          } = response.data.getAShippersShippingRequestsByStatus.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Approved applications loaded successfully",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "An error occured while trying to retrieve data",
            type: "is-danger"
          });
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadApprovedShippingRequests(this.currentPage);
    }
  }
};
</script>
